import React from "react";
import Nav from "react-bootstrap/Nav";
import { Collapse } from "react-bootstrap";
import SidebarMenu from "../Commons/SidebarMenu";
import HistoryHelper from "../../helpers/HistoryHelper.js";
import FotosHelper from "../../helpers/FotosHelper";
import { stringify } from "rebem-classname";
import isMobile from "ismobilejs";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Headroom from "react-headroom";
import IngresarDesplegable from "./IngresarDesplegable";
import { RiCloseFill } from "react-icons/ri";
import { FaUser } from "react-icons/fa";
import { AiFillHome, AiFillCamera } from "react-icons/ai";
import { MdAttachMoney, MdLuggage } from "react-icons/md";
import { BiCurrentLocation, BiTransfer } from "react-icons/bi";
import { ImUpload3 } from "react-icons/im";
import { IoIosEye, IoMdHeart } from "react-icons/io";
import { IoLocationOutline } from "react-icons/io5";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import Context from "../Login/ContextUser/Context";

import LoginModal from "./LoginModal";

const menuKey = "m";

export default class HomeMenu extends React.Component {
  constructor(props) {
    super(props);

    this.handleHistoryMenu = isMobile.any;
    this.isApp = window.location.href.includes("app");

    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.onPopState = this.onPopState.bind(this);
    this.onBackClick = this.onBackClick.bind(this);
    this.onOpenIngresarDesplegable = this.onOpenIngresarDesplegable.bind(this);
    this.onCloseIngresarDesplegable =
      this.onCloseIngresarDesplegable.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onOpenModalLogin = this.onOpenModalLogin.bind(this);
    this.state = {
      isVisible:
        !!this.handleHistoryMenu && HistoryHelper.shouldBeVisible(menuKey),
      mostrarMenu: false,
      openIngresarDesplegable: false,
      openLoginModal: false,
      menuDropdown: false,
    };
  }

  updateModal(isVisible, backbutton = false) {
    const eraVisible = this.state.isVisible;
    this.setState(
      {
        isVisible,
      },
      () => {
        if (!this.handleHistoryMenu) {
          return;
        }

        // abre el modal
        if (this.state.isVisible) {
          // si lo abre con el boton de adelante o atras no agrega entradas al history y modifica el evento para no disparar otro
          window.popStateMenu = backbutton;
          if (!backbutton) {
            HistoryHelper.push(menuKey);
          }
        } else if (eraVisible) {
          // si lo cierra siempre es un evento del menu para no ejecutar otro ya que modifica el history de cualquier forma
          window.popStateMenu = true;
          // si toco el boton atras remplazo la url para quitar el get y si no, hago un back para volver a la anterior en el history
          if (backbutton) {
            HistoryHelper.replace(menuKey);
          } else {
            HistoryHelper.back();
          }
        }
      }
    );
  }

  onShowMenuDropdown() {
    this.setState({ menuDropdown: !this.state.menuDropdown });
  }

  toggleMenu() {
    this.updateModal(!this.state.isVisible);
  }

  onBackClick() {
    // Entiendo que esta función controla si estamos en la ficha y tenemos un link que dirije al listado antes de elegir a dónde se va a volver con el botón de back, así que quito this.props.ficha
    if (this.props.linkAlListado) {
      if (document.referrer.indexOf(process.env.MIX_DOMINIO_WEB) !== -1) {
        window.history.go(-1);
      } else {
        window.location.href = "/buscar";
      }
    } else {
      window.location.href = !this.isApp
        ? process.env.MIX_DOMINIO_WEB
        : process.env.MIX_DOMINIO_APP;
    }
  }

  onPopState() {
    const isVisible = HistoryHelper.shouldBeVisible(menuKey);
    if (isVisible == this.state.isVisible) {
      return;
    }
    this.updateModal(isVisible, true);
  }
  componentDidMount() {
    if (this.handleHistoryMenu) {
      window.addEventListener("popstate", this.onPopState);
    }
    const { getSession } = this.context;
    getSession();
  }

  componentWillUnmount() {
    if (this.handleHistoryMenu) {
      window.removeEventListener("popstate", this.onPopState);
    }
  }
  handleScroll(evt) {
    if (
      !evt ||
      !evt.target ||
      !evt.target.body ||
      evt.target.scrollingElement
    ) {
      return;
    }

    let scrollTop = evt.target.scrollingElement.scrollTop;
    if (scrollTop > 250) {
      this.setState({
        mostrarMenu: true,
      });
    } else {
      this.setState({
        mostrarMenu: false,
      });
    }
  }

  onOpenIngresarDesplegable() {
    this.setState({
      openIngresarDesplegable: !this.state.openIngresarDesplegable,
    });
  }
  onCloseIngresarDesplegable() {
    this.setState({
      openIngresarDesplegable: false,
    });
  }
  onOpenModalLogin() {
    this.setState({
      openLoginModal: true,
      isVisible: false,
    });
  }
  onCloseModal() {
    this.setState({
      openLoginModal: false,
    });
  }

  render() {
    const block = "menu";
    const state = this.context.state;
    let nombreAnuncio = "";
    const classSidebar = isMobile.any
      ? "side-menu side-mobile"
      : "side-menu side-desktop";

    const modalLogin = this.state.openLoginModal && (
      <LoginModal onCloseLoginModal={this.onCloseModal} />
    );

    const sideBar = (
      <SidebarMenu
        placement={isMobile.any ? "end" : "start"}
        className={classSidebar}
        isVisible={this.state.isVisible}
        onHide={this.toggleMenu}
      >
        <div className={stringify({ block, elem: "boton-cerrar" })}>
          <div
            className={stringify({ block, elem: "login-cerrar" })}
            onClick={this.toggleMenu}
          >
            <RiCloseFill />
          </div>
        </div>
        <Nav
          variant="pills"
          className={`flex-column ${stringify({ block, elem: "login" })}`}
        >
          {state.email ? (
            <>
              <Nav.Item className={stringify({ block, elem: "login-user" })}>
                {state.picture ? (
                  <img
                    className={stringify({ block, elem: "fotoPerfil" })}
                    src={state.picture}
                  />
                ) : (
                  <FaUser />
                )}
                {state.name
                  ? "Hola " + state.name.split(" ")[0] + "!"
                  : "Hola!"}
              </Nav.Item>
              {state.tipo == 2 ? (
                <Nav.Item>
                  <Nav.Link href={process.env.MIX_URL_PDC_LITE}>
                    <span className="icon-dashboard" />
                    Acceder al Panel
                  </Nav.Link>
                </Nav.Item>
              ) : null}
              {state.tipo == 3 ? (
                <Nav.Item>
                  <Nav.Link href={process.env.MIX_URL_PDC}>
                    <span className="icon-dashboard" />
                    Acceder al Panel
                  </Nav.Link>
                </Nav.Item>
              ) : null}
            </>
          ) : (
            <>
              <Nav.Item>
                <Nav.Link onClick={this.onOpenModalLogin}>
                  <FaUser /> Inicia sesión o registrate
                </Nav.Link>
              </Nav.Item>
            </>
          )}
        </Nav>
        {state.email ? (
          <>
            <hr />
            <Nav
              variant="pills"
              className={`flex-column ${stringify({
                block,
                elem: "opciones",
              })}`}
            >
              <React.Fragment>
			  <Nav.Item>
                  <Nav.Link href="/mis-reservas/">
                    <MdLuggage /> Reservas
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link href="/favoritos/">
                    <IoMdHeart /> Favoritos
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link href="/vistos/">
                    <IoIosEye /> Vistos
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link href="/consultados/">
                    <BiTransfer /> Consultados
                  </Nav.Link>
                </Nav.Item>
              </React.Fragment>
            </Nav>
          </>
        ) : null}
        <hr />
        <Nav
          variant="pills"
          className={`flex-column ${stringify({ block, elem: "opciones" })}`}
        >
          <Nav.Item
            id="itemMenu-TopDestinos"
            onClick={() => this.onShowMenuDropdown()}
            className={this.state.menuDropdown ? "dropdown-abierto" : ""}
          >
            <button className="nav-link">
              <IoLocationOutline /> Destinos más populares
            </button>
            <span className="icon-topDestinos">
              {this.state.menuDropdown ? <IoIosArrowUp /> : <IoIosArrowDown />}
            </span>
            <Collapse in={this.state.menuDropdown}>
              <div className="div-items-topDestinos">
                <Nav.Link href="/Buenos-Aires/Capital-Federal/">
                  Ciudad Autónoma de Buenos Aires
                </Nav.Link>
                <Nav.Link href="/Buenos-Aires/Mar-Del-Plata/">
                  Mar del Plata
                </Nav.Link>
                <Nav.Link href="/Río-Negro/San-Carlos-De-Bariloche/">
                  Bariloche
                </Nav.Link>
                <Nav.Link href="/Mendoza/Ciudad-De-Mendoza/">Mendoza</Nav.Link>
                <Nav.Link href="/Misiones/Puerto-Iguazú/">
                  Puerto Iguazú
                </Nav.Link>
                <Nav.Link href="/Córdoba/Ciudad-De-Córdoba/">
                  Ciudad de Córdoba
                </Nav.Link>
                <Nav.Link href="/Salta/Ciudad-De-Salta/">Salta</Nav.Link>
                <Nav.Link href="/Córdoba/Villa-Carlos-Paz/">
                  Villa Carlos Paz
                </Nav.Link>
                <Nav.Link href="/Buenos-Aires/Pinamar/">Pinamar</Nav.Link>
                <Nav.Link href="/Buenos-Aires/Villa-Gesell/">
                  Villa Gesell
                </Nav.Link>
                <Nav.Link href="/Buenos-Aires/San-Clemente-Del-Tuyú/">
                  San Clemente del Tuyú
                </Nav.Link>
                <Nav.Link href="/Tierra-Del-Fuego/Ushuaia/">Ushuaia</Nav.Link>
                <Nav.Link href="/Santa-Cruz/El-Calafate/">Calafate</Nav.Link>
                <Nav.Link href="/Santa-Fe/Rosario/">Rosario</Nav.Link>
                <Nav.Link href="/Neuquén/San-Martín-De-Los-Andes/">
                  San Martín de los Andes
                </Nav.Link>
                <Nav.Link href="/Neuquén/Villa-La-Angostura/">
                  Villa La Angostura
                </Nav.Link>
              </div>
            </Collapse>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/ofertas-imperdibles/">
              <MdAttachMoney /> Ofertas Imperdibles
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/contacto.html">
              <span className="icon-atencion" /> Contacto
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <hr />
        <Nav
          variant="pills"
          className={`flex-column ${stringify({ block, elem: "opciones" })}`}
        >
          <Nav.Item>
            <Nav.Link href="/publicar.html">
              <ImUpload3 /> Publicar Alojamiento
            </Nav.Link>
          </Nav.Item>
          {state.email ? (
            <Nav.Item>
              <Nav.Link onClick={this.context.logOut}>
                <span className="icon-logout" /> Cerrar Sesión
              </Nav.Link>
            </Nav.Item>
          ) : null}
        </Nav>
      </SidebarMenu>
    );

    //Header en mobile
    // Por lo que entiendo, esto muestra items del HeaderMobile y los posiciona relativamente sólo si nos encontramos dentro de una ficha. Así que reemplazo this.props.ficha por flase.
    const itemsHeaderMobile = (
      <div
        className={stringify({
          block,
          mods: { noFix: this.props.noFix, posRelative: false },
        })}
      >
        <div className={stringify({ block, elem: "headerContainerMobile" })}>
          <div className={stringify({ block, elem: "buttonBack" })}>
            {/* Muestro el icono de volver atras en todas las pantallas menos en la del home */}
            {!this.props.home ? (
              <IconButton onClick={this.onBackClick}>
                <ArrowBackIosIcon />
              </IconButton>
            ) : null}
          </div>

          {/* si esta en la ficha muestro el nombre del anuncio en vez de el logo de AA */}
          {/* SUS */}
          {this.props.ficha ? (
            <div className={stringify({ block, elem: "contenedor-titulo" })}>
              <div className={stringify({ block, elem: "titulo" })}>
                {" "}
                <h1>
                  Alquiler {nombreAnuncio} en{" "}
                  {window.g.propiedad.nombre_localidad}
                </h1>
              </div>
            </div>
          ) : (
            <div
              className={stringify({
                block,
                elem: "logoMobile",
                mods: {
                  conScroll: this.state.mostrarMenu || this.props.iconoSiempre,
                },
              })}
            >
              <a href="/" title="AlquilerArgentina Alquileres temporarios">
                <img
                  src={FotosHelper.imgV4("logo-aa_h_280.png")}
                  alt="alquiler argentina"
                  srcSet={FotosHelper.imgV4("logo-aa_h.svg")}
                />
              </a>
            </div>
          )}
          <div>
            {sideBar}
            <a
              type="button"
              className={stringify({ block, elem: "boton" })}
              onClick={this.toggleMenu}
            >
              <MenuIcon />
            </a>
          </div>
        </div>
        {modalLogin}
      </div>
    );

    return !isMobile.any ? (
      <>
        <div
          className={stringify({ block, mods: { noFix: this.props.noFix } })}
        >
          <div className={`float-start ${stringify({ block, elem: "menu" })}`}>
            <a
              type="button"
              className={stringify({ block, elem: "boton" })}
              onClick={this.toggleMenu}
            >
              <MenuIcon />
            </a>
            {sideBar}
            <div
              className={stringify({
                block,
                elem: "logo",
                mods: {
                  conScroll: this.state.mostrarMenu || this.props.iconoSiempre,
                },
              })}
            >
              <a href="/" title="AlquilerArgentina Alquileres temporarios">
                <img
                  src={FotosHelper.imgV4("logo-aa_h_280.png")}
                  alt="alquiler argentina"
                  srcSet={FotosHelper.imgV4("logo-aa_h.svg")}
                />
              </a>
            </div>
          </div>
          <div className="float-end">
            <div
              className={`hidden-xs hidden-sm ${stringify({
                block,
                elem: "links",
              })}`}
            >
              <a
                className={stringify({ block, elem: "a" })}
                href="/publicar.html"
              >
                Publicar
              </a>
              {!state.email ? (
                <a
                  className={stringify({ block, elem: "a" })}
                  onClick={this.onOpenModalLogin}
                >
                  Ingresar
                </a>
              ) : (
                ""
              )}
              {state.tipo == 2 || state.tipo == 3 ? (
                <a
                  className={stringify({ block, elem: "a" })}
                  href={
                    state.tipo == 2
                      ? process.env.MIX_URL_PDC_LITE
                      : process.env.MIX_URL_PDC
                  }
                >
                  Ingresar al Panel
                </a>
              ) : (
                ""
              )}
            </div>
            {state.email && state.picture ? (
              <div
                className={stringify({
                  block,
                  elem: "foto",
                  mods: { mostrar: true },
                })}
              >
                <img
                  className={stringify({ block, elem: "img" })}
                  src={state.picture}
                />
              </div>
            ) : null}
          </div>
        </div>
        <div>
          {this.state.openIngresarDesplegable ? (
            <IngresarDesplegable
              turista={state.email}
              noFix={this.props.noFix}
            />
          ) : null}
        </div>
        {modalLogin}
      </>
    ) : (
      itemsHeaderMobile
    );
  }
}
HomeMenu.contextType = Context;
